<bb-form-element [form]="form" [label]="'RESPONSIVE_PLAYER_SIZING' | translate"
	[helpMessage]="'HELP.RESPONSIVE_SIZING' | translate">
	<bb-check name="playout-responsiveSizing" [(ngModel)]="responsiveSizing"
		(ngModelChange)="emitChange('responsiveSizing', $event)" [trueValue]="'true'" [falseValue]="'false'">
	</bb-check>
</bb-form-element>

<bb-form-element [form]="form" *ngIf="responsiveSizing === 'true'" [label]="'ASPECT_RATIO' | translate"
	[helpMessage]="'HELP.RESPONSIVE_ASPECT_RATIO' | translate">
	<bb-aspect-ratio-picker [(ngModel)]="aspectRatio" (ngModelChange)="emitChange('aspectRatio', $event)" name="playout-aspectRatio" [defaultOption]="defaultOption" class="input"></bb-aspect-ratio-picker>
</bb-form-element>

<div class="dimensions">
	<bb-form-element [label]="'WIDTH' | translate" [helpMessage]="'HELP.APPEARANCE_WIDTH' | translate">
		<bb-dimension name="playout-width" (change)="dimensionChanged('width')" [(ngModel)]="width"
			(ngModelChange)="emitChange('width', $event)" [useUnits]="'both'"></bb-dimension>
	</bb-form-element>

	<bb-form-element [label]="'HEIGHT' | translate" [helpMessage]="'HELP.APPEARANCE_HEIGHT' | translate"
		[hidden]="responsiveSizing === 'true'" class="flex">
		<bb-dimension name="playout-height" (change)="dimensionChanged('height')" [(ngModel)]="height"
			(ngModelChange)="emitChange('height', $event)" [useUnits]="'both'"></bb-dimension>

		<div [hidden]="width?.indexOf('%') > -1 || height?.indexOf('%') > -1" class="aspect-container">
			<label>
				<bb-check [(ngModel)]="lockAspectRatioFixedSize" (ngModelChange)="setAspectRatioFixedSize()"
					[ngModelOptions]="{standalone: true}"
					[disabled]="width?.indexOf('%') > -1 || height?.indexOf('%') > -1">
				</bb-check>
				{{ 'LOCK_ASPECT_RATIO' | translate }}
			</label>
			&nbsp;<span [hidden]="!aspectRatioFixedSize">({{ aspectRatioFixedSize | number:'1.0-2'}})</span>
		</div>
	</bb-form-element>
</div>
